import React, { memo } from 'react';
import { EditorContent } from 'components/layout-content';
import style from './index.module.scss';
import { Loading } from 'AurionCR/components';
import { PdfView } from 'components/pdf-view';
import { AppInput } from 'components/app-input';
import { apiMediaPrivate } from 'services/media-private-services';
import { useTranslate } from 'hooks/use-translate';
import { apiUserPatientProfileDocuments } from 'services/user-patient-profile-documents';
import { useIsBelowMd } from 'hooks/use-is-below-md';
import { MobileEmptyState } from 'components/mobile-empty-state';

interface Props {
  userPatientProfileID: string;
}
export const NotebooksFromRapid = memo<Props>(({ userPatientProfileID }) => {
  const { t } = useTranslate();

  const { data, error, isLoading } =
    apiUserPatientProfileDocuments.useGetUserPatientProfileDocumentMigrationQuery(
      userPatientProfileID,
    );

  const documentUrl = data?.documentURL;

  const { data: docBase64, isFetching } = apiMediaPrivate.useGetMediaPrivateBase64Query(
    { url: documentUrl || '' },
    { skip: !documentUrl },
  );

  // N2c (T3): below md a patient without a Rapid file gets the one empty state
  // instead of the viewer's black frame (the same condition as the file's
  // request: no document URL)
  const isBelowMd = useIsBelowMd();
  const isEmpty = isBelowMd && !isLoading && !documentUrl;

  return (
    <EditorContent
      InnerProps={{
        sx: { minHeight: '100%' },
        className: style.root,
      }}
    >
      <AppInput
        error={Boolean(error)}
        helperText={error ? t(error.message || 'error') : ''}
        value={documentUrl}
        disableClearable
        slotProps={{
          input: { readOnly: true },
        }}
      />
      {isEmpty ? (
        <MobileEmptyState />
      ) : (
        <PdfView title={documentUrl || ''} isLoading={isFetching} pdf={docBase64} />
      )}
      <Loading active={isLoading} />
    </EditorContent>
  );
});
